<template>
  <div
    class="text-input"
    :class="{
      'vp-mb-61': lastFieldInSection && isInvalid,
      'vp-mb-37': isInvalid,
      'vp-mb-16': !isInvalid,
    }"
  >
    <VpInput
      :label="
        field.is_mandatory && !field.is_optional
          ? field.name
          : field.name + ` ${$t('common.optionalWithBrackets')}`
      "
      width="416"
      v-model="inputModel.value"
      maxlength="20"
      :invalid="isInvalid"
      :errMsg="isInvalid ? errMsg : ''"
      @input="emitUpdate"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    field: {},
    lastFieldInSection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputModel: null,
    };
  },
  beforeMount() {
    this.inputModel = cloneDeep(this.field);
  },
  methods: {
    emitUpdate() {
      this.$emit("updateTextEmit", this.inputModel);
    },
  },
  computed: {
    errMsg() {
      return `${this.field.name} can't exceed 20 characters.`;
    },
    isInvalid() {
      const maxLength = 20;
      const fieldValueLength = this.inputModel?.value?.length ?? 0;

      return fieldValueLength > maxLength;
    },
  },
};
</script>
<style lang="scss">
.text-input {
  width: 416px !important;
  .md-field.md-theme-default .md-input {
    padding-inline-end: 18px;
  }
  .md-field.md-theme-default.md-inline {
    width: 416px !important;
  }
}
</style>
